module.exports = __webpack_public_path__ + "static/kids_running-204086f117d7ee35053f6befd1c6255e.webp";